import { JsonObject } from '@/lib/helpers';

export type ThreadHistoryStatus = 'pinned' | 'archived';

export class ThreadHistoryModel {
  threadId: string;
  archivedAt: number;
  pinnedAt: number;
  status: ThreadHistoryStatus;

  constructor(props: JsonObject = {}) {
    const data = props as Record<keyof ThreadHistoryModel, unknown>;
    this.threadId = (data.threadId as string) || '';
    this.archivedAt = (data.archivedAt as number) || 0;
    this.pinnedAt = (data.pinnedAt as number) || 0;
    this.status = (data.status as ThreadHistoryStatus) || 'archived';
  }
}
